export const getVisibleLines = (el: HTMLParagraphElement): number => {
  const oneLineTemp = document.createElement('span');
  oneLineTemp.textContent = 'M';
  oneLineTemp.style.visibility = 'hidden';
  oneLineTemp.style.display = 'inline-block';
  el.appendChild(oneLineTemp);
  const lineHeight = oneLineTemp.offsetHeight;
  el.removeChild(oneLineTemp);
  return Math.floor(el.offsetHeight / lineHeight);
};

export const scrollElementIntoViewHorizontally = (
  container: HTMLElement,
  element: HTMLElement,
  behavior: ScrollBehavior = 'smooth'
) => {
  const containerLeft = container.scrollLeft;
  const containerRight = containerLeft + container.clientWidth;

  const elementLeft = element.offsetLeft;
  const elementRight = elementLeft + element.offsetWidth;

  let newScrollLeft = container.scrollLeft;

  if (elementLeft < containerLeft) {
    // Element is cut off on the left
    newScrollLeft = elementLeft;
  } else if (elementRight > containerRight) {
    // Element is cut off on the right
    newScrollLeft = elementRight - container.clientWidth;
  }

  if (newScrollLeft !== container.scrollLeft) {
    container.scrollTo({
      left: newScrollLeft,
      behavior,
    });
  }
};
